import { Box, Stack, Theme } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { ShopsInfo } from '../../../model/shops.response';
import { getAddressLine, getPrettyPhoneNumber } from '../../../utils/Utilities';
import { PreferredShopIcon } from '../../shared/Svg-icons/App-Icons';
import {
  PreferredShopTypography,
  ShopAddressTypography,
  ShopNameTypography,
  ShopPhoneNumberAndWebSiteTypography,
} from './ShopAddress-Styles';

interface Shop {
  shop: ShopsInfo;
  buttonEnabled: boolean;
  confirm?: boolean;
}

const Address = (prop: Shop) => {
  const theme: Theme = useTheme();

  return (
    <Box flexGrow={1}>
      {prop.shop.tier === 'Tier1' && (
        <Stack direction="row" spacing={1} justifyContent="flex-start" alignItems="center" data-testid="shop_address">
          <PreferredShopIcon fontSize="small" sx={{ color: '#ffc320' }} />
          <PreferredShopTypography variant="caption" display="block" gutterBottom>
            Preferred Shop
          </PreferredShopTypography>
        </Stack>
      )}
      <ShopNameTypography variant="body2" sx={{ fontFamily: `${theme.custom.styles.primaryDescription}` }}>
        {prop.shop.name}
      </ShopNameTypography>
      {!!prop.confirm && (
        <ShopAddressTypography variant="body2">Are you sure you want to select this location?</ShopAddressTypography>
      )}
      {!prop.confirm && (
        <>
          <ShopAddressTypography variant="body2">{getAddressLine(prop.shop)}</ShopAddressTypography>
          <ShopPhoneNumberAndWebSiteTypography variant="body2">
            {getPrettyPhoneNumber(prop.shop.contactMethodDetail.primaryPhoneNumber)}
          </ShopPhoneNumberAndWebSiteTypography>
        </>
      )}
    </Box>
  );
};

export default Address;
